/**
 * @description DashBoard dashBoard
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const dashBoardBiz = new Logic()

dashBoardBiz.deleteBoard = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dashBoard.deleteBoard,
    data: data
  })
}

dashBoardBiz.findBoard = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dashBoard.findBoard,
    data: data
  })
}

dashBoardBiz.saveBoard = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dashBoard.saveBoard,
    data: data
  })
}

dashBoardBiz.updateBoard = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dashBoard.updateBoard,
    data: data
  })
}

dashBoardBiz.findBoardById = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dashBoard.findBoardById,
    data: data
  }, false, true)
}

dashBoardBiz.searchKpi = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dashBoard.searchKpi,
    data: data
  })
}

dashBoardBiz.setDashTimer = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dashBoard.setDashTimer,
    data: data
  })
}

dashBoardBiz.getAbsoluteTime = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dashBoard.getAbsoluteTime,
    data: data
  }, false, true)
}

export default dashBoardBiz
